module.exports = __webpack_public_path__ + "img/racecourse_mauritius-turf.45dd5502.svg";